<div class="form-group">
  <label [hidden]="hideLabel" for="SelectedObject">{{ labelText }}</label>
  <ng-select required [items]="selectionList$ | async" bindLabel="Name" bindValue="BankId" [multiple]="false"
             [hideSelected]="true"
             [loading]="selectionListLoading" [typeahead]="selectionListInput$" [(ngModel)]="selectedObjectId"
             name="SelectedObject" placeholder="{{selectObjectText}}" (change)=selectedObjectChanged($event)>
  </ng-select>
</div>
